"use client";

import CarouselCategories from "./carouselCategories";
import CarouselDefault from "./carouselDefault";
import CarouselRecipes from "./carouselRecipes";

/**
 * @typedef {import("@prismicio/client").Content.CarrouselSlice} CarrouselSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<CarrouselSlice>} CarrouselProps
 * @type {import("react").FC<CarrouselProps>}
 */
const Carrousel = ({ slice }) => {
  
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`${slice.variation === "default" ? "bg-beige pt-10 md:py-20" : ""} flex flex-col overflow-visible gap-6`}
    >
      {slice.variation === "default" && (
       <CarouselDefault slice={slice} />
      )}
      {slice.variation === "carouselRecipe" && (
        <CarouselRecipes slice={slice} />
      )}
      {slice.variation === "carouselCategories" && (
        <CarouselCategories slice={slice} />
      )}
    </section>
  );
};

export default Carrousel;
